import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class CustomerService extends RestfulService<Models.Customer> {

  constructor(public restService: RestService) {
    super(Models.Customer);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('customers');
  }

}
